async function CreateUpdateChoppers(
    chopperid,
    choppername,
    createdbyid,
    choppermodelid,
    materialtypeid,
    motorpositionid,
    cutterheadpositionid,
    cuttermountingarrangementid,
    trimremovalmethodid,
    materialthickness,
    materialspeed,
    materialwidth,
    inletdiameter,
    airflowthroughcutter,
    bladesincutter,
    desiredpiecesize,
    cutterrotatingspeed,
    pressureloss,
    knives,
    bearings,
    oilmist,
    trimgeneratedby,
    paintcolor,
    voltage,
    flywheel,
    trimspermachine,
    numberofmachines,
    papergrades,
    notes

) {

    if (true) {

        let response;

        let params = {
            "@ChopperID": chopperid,
            "@ChopperName": choppername,
            "@CreatedByID": createdbyid,
            "@ChopperModelID": choppermodelid,
            "@MaterialTypeID": materialtypeid,
            "@MotorPositionID": motorpositionid,
            "@CutterHeadPositionID": cutterheadpositionid,
            "@CutterMountingArrangementID": cuttermountingarrangementid,
            "@TrimRemovalMethodID": trimremovalmethodid,
            "@MaterialThickness": materialthickness,
            "@MaterialSpeed": materialspeed,
            "@MaterialWidth": materialwidth,
            "@InletDiameter": inletdiameter,
            "@AirflowThroughCutter": airflowthroughcutter,
            "@BladesInCutter": bladesincutter,
            "@DesiredPieceSize": desiredpiecesize,
            "@CutterRotatingSpeed": cutterrotatingspeed,
            "@PressureLoss": pressureloss,
            "@Knives": knives,
            "@Bearings": bearings,
            "@OilMist": oilmist,
            "@TrimGeneratedBy": trimgeneratedby,
            "@PaintColor": paintcolor,
            "@Voltage": voltage,
            "@FlyWheel": flywheel,
            "@TrimsPerMachine": trimspermachine,
            "@NumberOfMachines": numberofmachines,
            "@PaperGrades": papergrades,
            "@Notes": notes
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "145",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "TrimChoppers",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);
    }
}

export default CreateUpdateChoppers;